<template>
  <span class="text-no-wrap">
    <v-icon :color="contractStatus.color" class="mr-2">{{ contractStatus.icon }}</v-icon>
    <span v-if="hasTitle" :class="contractStatus.color + '--text'">{{ contractStatus.name }}</span>
  </span>
</template>


<script>
import contractStatusMixin from '@/mixins/contractStatus.mixin'


export default {
  mixins: [contractStatusMixin],


  props: {
    value: {
      type: Number
    },
    hasTitle: {
      type: Boolean,
      default: true
    }
  },


  computed: {
    contractStatus () {
      return this.getContractStatusById(this.value)
    }
  }
}
</script>
